<template>
  <div class="sf-accordion">
    <slot />
  </div>
</template>
<script lang="ts">
export default {
  name: 'SfAccordion',
}
</script>
<style lang="scss" scoped>
@import './sf-accordion';
</style>
